export function getCurrentPartnerId() {
  return localStorage.getItem("partnerId")
    ? localStorage.getItem("partnerId")
    : 0;
}

export function setCurrentPartnerId(partnerId) {
  localStorage.setItem("partnerId", parseInt(partnerId));
}
